import { Injectable } from '@angular/core';
// import {DefaultSessionState, StateKey} from '../../main/types/elvis.types';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private localStorage: Storage;

  constructor() {
    this.localStorage = window.localStorage;
  }

  public get(key: string): any {
    return JSON.parse(this.localStorage.getItem(key));
  }

  public set(key: string, value: any): void {
    this.localStorage.setItem(key, JSON.stringify(value));
  }

  public remove(key: string): void {
    this.localStorage.removeItem(key);
  }

  public getFromState(state: string, key: string): any {
    const cashedState = this.get(state);
    if (cashedState) {
      return cashedState[key];
    } else {
      return null;
    }
  }

  public setToState(state: string, key: string, value: any): void {
    const sourceState = this.get(state);
    this.set(state, { ...sourceState, [key]: value });
  }

  public removeFromState(state: string, key: string): void {
    const sourceState = this.get(state);
    delete sourceState[key];
    this.set(state, { ...sourceState });
  }

  public clear(): void {
    this.localStorage.clear();
  }

  // public initialize(): void {
  //   if (!this.get(StateKey.SESSION) || !this.getFromState(StateKey.SESSION, 'token')) {
  //     this.set(StateKey.SESSION, new DefaultSessionState());
  //   }
  //   this.set(StateKey.MASTER, {});
  // }
}
